import { useCallback, useState } from 'react'
import type { TranscriptEntry } from '../context/VoiceAgentCallContext'

export const useVoiceTranscript = () => {
  const [transcript, setTranscript] = useState<TranscriptEntry[]>([])

  const processEntry = useCallback(
    (role: 'user' | 'assistant', text: string, isFinal: boolean) => {
      setTranscript((prev) => {
        const lastIndex = prev.length - 1
        const last = prev[lastIndex]

        if (last && last.role === role && !last.isFinal) {
          const updated = [...prev]
          updated[lastIndex] = { role, text, isFinal, timestamp: Date.now() }
          return updated
        }

        return [...prev, { role, text, isFinal, timestamp: Date.now() }]
      })
    },
    []
  )

  const clear = useCallback(() => setTranscript([]), [])

  return { transcript, processEntry, clear }
}
